import { Routes } from "@angular/router";
import { loadComponentWithErrorHandling } from "@apps/patient-core/src/app/utils/routing";

export const CHECK_IN_ROUTES: Routes = [
  {
    path: "",
    loadComponent: loadComponentWithErrorHandling(() => import("./check-in.component").then((m) => m.CheckInComponent)),
  },
];
